"use client";
import { useCallback, useSyncExternalStore } from "react";
import { readMyHotkey, subscribeMyHotkey, writeMyHotkey } from "@/lib/myMiner";

export interface MyHotkey {
  hotkey: string | null;
  /** Marks `hotkey` as mine; marking the one already marked clears it. */
  toggle: (hotkey: string) => void;
  clear: () => void;
}

// The server has no idea what this browser remembers; it renders "nothing marked" and the
// client fills it in after hydration.
const readServer = () => null;

export function useMyHotkey(): MyHotkey {
  const hotkey = useSyncExternalStore(subscribeMyHotkey, readMyHotkey, readServer);
  const toggle = useCallback((next: string) => writeMyHotkey(readMyHotkey() === next ? null : next), []);
  const clear = useCallback(() => writeMyHotkey(null), []);
  return { hotkey, toggle, clear };
}
